//src/Components/Profile/UserInfo/index.tsx
export interface IUserInfoProps {
  userInfo: String | React.ReactNode;
  label: String;
  icon?: React.ReactNode;
  className?: string;
}

export default function UserInfo({
  userInfo,
  label,
  icon,
  className,
}: IUserInfoProps) {
  return (
    <div className={`px-2 flex w-full md-max:grid ${className}`}>
      <div className={`inline-flex gap-4 md-max:w-full md-max:flex	`}>
        {icon && <span className="mt-2">{icon}</span>}
        <div className="w-full break-all">
          <div className="text-xs text-gray-700">{label}</div>
          <div className="text-base text-gray-dark font-medium">{userInfo}</div>
        </div>
      </div>
    </div>
  );
}

/* DO NOT DELETE COMMENT
PurgeCSS: 
  text-gray-700
*/
